import { createSlice } from "@reduxjs/toolkit"
import { persistReducer } from 'redux-persist'
import createIndexedDBStorage from 'redux-persist-indexeddb-storage'
 
const storage = createIndexedDBStorage({
    name: 'SHoT_Backend',
    version: 1,
    storeName: 'M_State',
})
 
export const stateSlice = createSlice({
    name: 'M_State',
    initialState: {
        StateKeyValue: [],
        StateQuantity: 0,
    },
    reducers: {
        addM_State(state, action) {
            const tempObj = state.StateKeyValue.find(obj => obj.key === action.payload.key)
            if (tempObj) {
                state.StateKeyValue = state.StateKeyValue.map(obj => {
                    if (obj.key === action.payload.key) {
                        return { key: obj.key, value: action.payload.value }
                    } return obj
                })
            } else {
                state.StateKeyValue.push({ key: action.payload.key, value: action.payload.value })
                state.StateQuantity++
            }
        },
        removeM_State(state, action) {
            const tempObj = state.StateKeyValue.find(obj => obj.key === action.payload.key)
            if (tempObj) {
                state.StateKeyValue = state.StateKeyValue.filter(obj => obj.key !== action.payload.key)
                state.StateQuantity--
            }
        },
        DeleteAll_M_State(state) {
            state.StateKeyValue = []
            state.StateQuantity = 0
        }
    }
})
export const M_StateActions = stateSlice.actions
 
const persistConfig = {
    key: 'M_State',
    version: 1,
    storage: storage,
}
export const persistedReducer = persistReducer(persistConfig, stateSlice.reducer)